import ReactiveWidget from "lib/reactiveWidget";

import $              from "jquery"
import select2        from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

class CreateAdminWidget extends ReactiveWidget  {
  bind() {
    this.form = this.root.find('form')
    bindFormActions.call(this)
  }

  render() {
  }
}

var bindFormActions = function() {
  let roleSelect = document.querySelector('.select-admin-role')
  $(roleSelect).select2({
    placeholder: 'Select',
    allowClear: true,
    theme: "bootstrap"
  }).on('change', (e) => {
    handleAccount(e.target.value)
  })

}

var handleAccount = function(role) {
  let accountSelect = document.querySelector('.select-account')
  let text = ''
  let allOptions = []

  if (role.includes("superadmin")) {
    for (var i = 0; i < accountSelect.children.length; i++) {
      allOptions.push(accountSelect.children[i].value)
    }
    text = 'Superadmin role has been selected. Please select All Acccounts'
    $(accountSelect).val(null)
    $(accountSelect).val(allOptions)
  } else {
    text = 'Select'
    $(accountSelect).val(null)
  }

  $(accountSelect).select2({
    placeholder: text,
    allowClear: true,
    theme: "bootstrap"
  });
}

export default CreateAdminWidget
